import AccordionItemHandler from 'components/forms/new/AccordionItemHandler';
import { useState } from 'react';
import PlansDropdown from '../formFields/PlansDropdown';
import DefaultPlan from '../formFields/DefaultPlan';
import BillTo from '../formFields/BillTo';
import BillingToggles from '../formFields/BillingToggles';
import Surcharge from '../formFields/Surcharge';
import AllowPlansPerNumber from '../formFields/AllowPlansPerNumber';
import TrackingName2 from '../formFields/TrackingName2';
import TrackingOption2 from '../formFields/TrackingOption2';
import MinUserCount from '../formFields/MinUserCount';
import MinResourceAccountCount from '../formFields/MinResourceAccountCount';
import { useCompanyForm } from '../../hooks/useCompanyForm';

import useGetPlans from '@/queries/useGetPlans';

const BillingInvoiceSettings = ({
    errors,
    touched,
    darkMode,
    isCompany,
    defaultPlansData,
}) => {
    const [plans, setPlans] = useState([]);
    const { formData, mode } = useCompanyForm();

    const getPlansProps = isCompany
        ? { companyId: formData?.id, setPlans }
        : {
              partnerId: formData?.partnerId,
              wholesalerId: formData?.wholesalerId,
              setPlans,
          };
    const { isLoading: isLoadingPlans } = useGetPlans(getPlansProps);

    const formFields = [
        isCompany && (
            <PlansDropdown
                key="plans"
                plans={plans}
                isLoadingPlans={isLoadingPlans}
                errors={errors}
                touched={touched}
                darkMode={darkMode}
            />
        ),
        <DefaultPlan
            key="defaultPlan"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
            defaultPlansData={defaultPlansData}
        />,
        <BillTo
            key="billTo"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
            isCompany={isCompany}
        />,
        <BillingToggles key="toggles" darkMode={darkMode} />,
        <Surcharge
            key="surcharge"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
        />,
        mode !== 'Wholesaler' && (
            <AllowPlansPerNumber
                key="allowPlansPerNumber"
                errors={errors}
                touched={touched}
                darkMode={darkMode}
            />
        ),
        <TrackingName2
            key="trackingName2"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
        />,
        <TrackingOption2
            key="trackingOption2"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
        />,
        <MinUserCount
            key="minBillableUsers"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
        />,
        <MinResourceAccountCount
            key="minBillableResourceAccounts"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
        />,
    ];

    return (
        <AccordionItemHandler
            index={0}
            key="companyBillingInvoiceSettings"
            label="Billing Settings"
            errors={errors}
            touched={touched}
            defaultIsOpen={true}>
            {formFields.filter(Boolean)}
        </AccordionItemHandler>
    );
};

export default BillingInvoiceSettings;
